import EditProfileContainer from "../../Componant/Users/EditProfile";

const EditProfile = () => {
  return (
    <div className="page-body">
      <EditProfileContainer />
    </div>
  );
};

export default EditProfile;
